import React, { useEffect } from "react";
import Grid from "@mui/material/Grid";
import styles from "./EditProfile.module.css";
import TextField from "component/textField/TextField";
import AppButton from "component/button/AppButton";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { updateProfileSchema } from "schemas/profile/profileSchemas";
import AuthModalLayout from "component/authModalLayout/AuthModalLayout";

import AppBackdrop from "component/appBackdrop/AppBackdrop";
import ProfilePhoto from "./ProfilePhoto";
import { useUpdateProfile } from "api/mutations/profile";
import PhoneNumberInput from "component/phoneNumberInput/PhoneNumberInput";


function EditProfile({ profileDetails, handleClose }) {

  const {
    register,
    handleSubmit,
    setValue,
    trigger,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(updateProfileSchema)
  });
  const phone = watch('phone', '')

  useEffect(()=>{
    if(phone){
      trigger('phone')
    }
  }, [phone])
  useEffect(()=>{
      setValue('lastName', profileDetails.lastName)
      setValue('firstName', profileDetails.firstName)
      setValue('phone', profileDetails.phone)
      setValue('employmentType', profileDetails.employmentType)
  }, [profileDetails])


  const { isLoading, mutate, setOpenModal, openModal } = useUpdateProfile();

  return (
    <div className={styles.edit_profile}>
      <Grid container spacing={1}>
        <Grid item xs={12} lg={2}>
          <div className={styles.image_container}>
            <ProfilePhoto profileDetails={profileDetails} />
          </div>
        </Grid>
        <Grid item xs={12} lg={10}>
          <div className={styles.profile_form}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <TextField
                    required={true}
                    errors={errors}
                    register={register}
                    name="firstName"
                    type="text"
                    label="First Name"
                    disabled={true}
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <TextField
                    required={true}
                    errors={errors}
                    register={register}
                    name="lastName"
                    type="text"
                    label="Last Name"
                    disabled={true}
                  />
                </div>
              </Grid>

              {/* <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <LabeledSelect
                    name="employmentType"
                    data={[
                      {
                        label: "Employed",
                        value: "employed",
                      },
                      {
                        label: "Pensioner",
                        value: "pensioner",
                      },
                      {
                        label: "Unemployed",
                        value: "unemployed",
                      },
                      {
                        label: "Self Employed",
                        value: "self_employed",
                      },
                    ]}
                    register={register}
                    errors={errors}
                    label="Employment Type"
                    placeholder="Select Employment Type"
                  />
                </div>
              </Grid> */}

              {/* <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <TextField
                    errors={errors}
                    register={register}
                    name="email"
                    type="email"
                    label="Email"
                  />
                </div>
              </Grid> */}
              <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <PhoneNumberInput name='phone' value={phone} setValue={setValue} errors={errors} />
                  {/* <TextField
                    required={true}
                    errors={errors}
                    register={register}
                    name="phone"
                    type="number"
                    label="Phone Number"
                  /> */}
                </div>
              </Grid>
              {/* <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <TextField
                    errors={errors}
                    register={register}
                    name="bvn"
                    type="number"
                    label="BVN"
                  />
                </div>
              </Grid> */}
              {/* <Grid item xs={12} sm={6}>
                <div className={styles.field}>
                  <TextField
                    errors={errors}
                    register={register}
                    name="nin"
                    type="number"
                    label="NIN"
                  />
                </div>
              </Grid> */}
              <Grid item xs={12} sm={12}>
                <div className={styles.btn}>
                  <AppButton
                    fullwidth
                    textColor="#FFFFFF"
                    btnBg="#0089FF"
                    btnText="Save Changes"
                    handleAction={handleSubmit(mutate)}
                    loading={isLoading}
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Grid>
      </Grid>

      <AppBackdrop
        openModal={openModal}
        handleCloseModal={() => {}}
        children={
          <AuthModalLayout
            handleClose={() => {
              setOpenModal(false);
              handleClose();
            }}
            icon={'success'}
            primaryText="Success"
            secondaryText="Your profile information has been updated"
          />
        }
      />
    </div>
  );
}

export default EditProfile;
